module.exports = __webpack_public_path__ + "media/homepage/redbull-86d1848c.png";